export default "__VITE_ASSET__bccf5138__"